export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        id: value.id,
        description: value.description,
        glob: value.glob,
        pattern: value.pattern,
        nameField: value.nameField,
        dateField: value.dateField,
        timeField: value.timeField,
        dateFormat: value.dateFormat,
        timeFormat: value.timeFormat,
        static: value.static,
        system: value.system
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        id: value.id,
        description: value.description,
        glob: value.glob,
        pattern: value.pattern,
        nameField: value.nameField,
        dateField: value.dateField,
        timeField: value.timeField,
        dateFormat: value.dateFormat,
        timeFormat: value.timeFormat,
        static: value.static,
        system: value.system
      })
    }
  },
  CURRENT (state, value) {
    // need to make a more graceful update to minimize screen disruptions
    if (value) {
      for (const prop of [
        'id',
        'description',
        'glob',
        'pattern',
        'nameField',
        'dateField',
        'timeField',
        'dateFormat',
        'timeFormat',
        'type',
        'multipleFiles',
        'setupMethod',
        'static'
      ]) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
      state.current.system = value.system
    } else {
      state.current = {
        id: '',
        description: '',
        glob: '',
        pattern: '',
        nameField: 0,
        dateField: 0,
        timeField: 0,
        dateFormat: '',
        timeFormat: '',
        setupMethod: '',
        static: false,
        type: '',
        multipleFiles: true,
        system: ''
      }
      state.update = {
        id: '',
        description: '',
        glob: '',
        pattern: '',
        nameField: 0,
        dateField: 0,
        timeField: 0,
        dateFormat: '',
        setupMethod: '',
        timeFormat: '',
        type: '',
        multipleFiles: true,
        static: false
      }
    }
  },
  RESET (state, value) {
    Object.assign(state.update, state.current)
  },
  UPDATE_ALL (state, value) {
    Object.assign(state.update, value)
  },
  UPDATE_DESCRIPTION (state, value) {
    state.update.description = value
  },
  UPDATE_GLOB (state, value) {
    state.update.glob = value
  },
  UPDATE_PATTERN (state, value) {
    state.update.pattern = value
  },
  UPDATE_NAME_FIELD (state, value) {
    state.update.nameField = value
  },
  UPDATE_DATE_FIELD (state, value) {
    state.update.dateField = value
  },
  UPDATE_TIME_FIELD (state, value) {
    state.update.timeField = value
  },
  UPDATE_DATE_FORMAT (state, value) {
    state.update.dateFormat = value
  },
  UPDATE_TIME_FORMAT (state, value) {
    state.update.timeFormat = value
  },
  UPDATE_STATIC (state, value) {
    state.update.static = value
  },
  UPDATE_SETUP_METHOD (state, value) {
    state.update.setupMethod = value
  },
  UPDATE_MULTIPLE_FILES (state, value) {
    state.update.multipleFiles = value
  },
  UPDATE_TYPE (state, value) {
    state.update.type = value
  }
}
